/* ============================================================
   Xtra theme — front-end behaviour
   ============================================================ */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};

  /* ---------- helpers ---------- */
  function scope(ctx) { return ctx && typeof ctx.querySelector === 'function' ? ctx : document; }
  function $(sel, ctx) { return scope(ctx).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call(scope(ctx).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el && el.addEventListener) el.addEventListener(ev, fn, opts); }

  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100);
    function withDelims(num, precision, thousands, decimal) {
      num = num.toFixed(precision);
      var parts = num.split('.');
      var int = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? int + decimal + parts[1] : int;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return withDelims(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelims(value, 0, ' ', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }
  window.formatMoney = formatMoney;

  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- overlay + drawers ---------- */
  var overlay = $('[data-overlay]');
  function openOverlay() {
    if (!overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
    document.body.classList.add('no-scroll');
  }
  function closeOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-visible');
    document.body.classList.remove('no-scroll');
    setTimeout(function () { if (!$('.drawer.is-open')) overlay.hidden = true; }, 300);
  }
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    openOverlay();
    var f = d.querySelector('button, [href], input, select, textarea');
    if (f) setTimeout(function () { f.focus(); }, 220);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    closeOverlay();
  }
  window.themeDrawer = { open: openDrawer, close: closeDrawers };

  on(overlay, 'click', closeDrawers);
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); closeMegaMenus(); closeSearchResults(); }
  });

  /* ---------- announcement bar ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var slides = $$('.announcement-slide', bar);
    if (slides.length > 1) {
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, 4500);
    }
    var close = $('.announcement__close', bar);
    on(close, 'click', function () {
      bar.hidden = true;
      try { sessionStorage.setItem('announcement-closed', '1'); } catch (err) {}
    });
    try { if (sessionStorage.getItem('announcement-closed') === '1') bar.hidden = true; } catch (err) {}
  });

  /* rotating utility usps on mobile */
  var usps = $$('.utility__usp');
  if (usps.length > 1) {
    usps.forEach(function (u, idx) { u.classList.toggle('is-active', idx === 0); });
    var ui = 0;
    setInterval(function () {
      usps[ui].classList.remove('is-active');
      ui = (ui + 1) % usps.length;
      usps[ui].classList.add('is-active');
    }, 4000);
  }

  /* ---------- mega menu ---------- */
  function closeMegaMenus() {
    $$('.nav-bar__item.is-open').forEach(function (li) {
      li.classList.remove('is-open');
      var t = $('.nav-bar__link', li);
      if (t && t.setAttribute) t.setAttribute('aria-expanded', 'false');
    });
  }
  $$('.nav-bar__item--has-menu').forEach(function (item) {
    var link = $('.nav-bar__link', item);
    var timer;
    function open() { clearTimeout(timer); closeMegaMenus(); item.classList.add('is-open'); if (link && link.setAttribute) link.setAttribute('aria-expanded', 'true'); }
    function close() { timer = setTimeout(function () { item.classList.remove('is-open'); if (link && link.setAttribute) link.setAttribute('aria-expanded', 'false'); }, 140); }
    on(item, 'mouseenter', open);
    on(item, 'mouseleave', close);
    on(link, 'focus', open);
    on(link, 'keydown', function (e) {
      if (e.key === 'Enter' && !item.classList.contains('is-open')) { e.preventDefault(); open(); }
    });
    on(item, 'focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
  });

  /* ---------- mobile nav ---------- */
  $$('[data-mobile-panel-open]').forEach(function (btn) {
    on(btn, 'click', function () {
      var id = btn.getAttribute('data-mobile-panel-open');
      $$('.mobile-nav__panel').forEach(function (p) { p.classList.toggle('is-active', p.id === id); });
    });
  });

  /* ---------- sliders ---------- */
  $$('[data-slider]').forEach(function (slider) {
    var track = $('.slider__track', slider);
    var prev = $('[data-slider-prev]', slider);
    var next = $('[data-slider-next]', slider);
    var dotsWrap = $('.slider__dots', slider);
    var counter = $('.slider__count', slider);
    if (!track) return;

    function step() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function pages() { return Math.max(1, Math.ceil(track.scrollWidth / Math.max(1, track.clientWidth))); }
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }

    function update() {
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      if (dotsWrap) {
        $$('.slider__dot', dotsWrap).forEach(function (d, i) { d.classList.toggle('is-active', i === current()); });
      }
      if (counter) counter.textContent = (current() + 1) + ' / ' + pages();
    }
    on(prev, 'click', function () { track.scrollBy({ left: -step() * Math.max(1, Math.floor(track.clientWidth / step())), behavior: 'smooth' }); });
    on(next, 'click', function () { track.scrollBy({ left: step() * Math.max(1, Math.floor(track.clientWidth / step())), behavior: 'smooth' }); });
    on(track, 'scroll', function () { window.requestAnimationFrame(update); });
    window.addEventListener('resize', update);

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var p = 0; p < pages(); p++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'slider__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (p + 1));
        (function (index) { on(dot, 'click', function () { track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' }); }); })(p);
        dotsWrap.appendChild(dot);
      }
    }
    update();
  });

  /* ---------- tabs ---------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var tabs = $$('.tabs__tab', wrap);
    tabs.forEach(function (tab) {
      on(tab, 'click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        $$('.tabs__panel', wrap).forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
      });
    });
  });

  /* ---------- quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.qty');
    var input = $('input', wrap);
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    v = btn.getAttribute('data-qty') === 'up' ? v + 1 : Math.max(min, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart ---------- */
  function getSectionsToRender() { return ['cart-drawer', 'cart-icon-bubble']; }

  function refreshCartUI() {
    fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(function () {});
  }

  function renderCartDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return refreshCartUI();
    fetch(routes.root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer .drawer__inner');
        var target = drawer.querySelector('.drawer__inner');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        refreshCartUI();
      })
      .catch(refreshCartUI);
  }
  window.renderCartDrawer = renderCartDrawer;

  /* add to cart (product forms + quick add) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.classList.add('loading'); btn.disabled = true; }

    var data = new FormData(form);
    data.append('sections', getSectionsToRender().join(','));

    fetch(routes.cart_add, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: data })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          toast(res.description || res.message || strings.cartError || 'Could not add to cart');
          return;
        }
        toast(strings.added || 'Added to cart');
        renderCartDrawer();
        if (window.theme.cartDrawer) setTimeout(function () { openDrawer('CartDrawer'); }, 120);
      })
      .catch(function () { toast(strings.cartError || 'Something went wrong'); })
      .finally(function () {
        if (btn) { btn.classList.remove('loading'); btn.disabled = false; btn.innerHTML = original; }
      });
  });

  /* change line quantity / remove */
  function changeLine(line, quantity, scope) {
    var body = { line: line, quantity: quantity, sections: getSectionsToRender().join(',') };
    if (scope) scope.classList.add('loading');
    return fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        renderCartDrawer();
      })
      .catch(function () { toast(strings.cartError || 'Something went wrong'); });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-cart-remove'), 0, rm.closest('.cart-item, .cart-drawer-item')); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-quantity]');
    if (!input) return;
    changeLine(input.getAttribute('data-cart-quantity'), input.value, input.closest('.cart-item, .cart-drawer-item'));
  });

  /* ---------- predictive search ---------- */
  function closeSearchResults() { $$('.search-results').forEach(function (r) { r.hidden = true; }); }
  $$('[data-predictive-search]').forEach(function (wrap) {
    var input = $('input[type=search]', wrap);
    var results = $('.search-results', wrap);
    var defaults = results ? results.innerHTML : '';
    var timer;
    if (!input || !results) return;

    on(input, 'focus', function () { results.hidden = false; });
    on(input, 'input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = defaults; results.hidden = false; return; }
      timer = setTimeout(function () {
        fetch(routes.predictive_search + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,article&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('#PredictiveSearchResults');
            results.innerHTML = inner ? inner.innerHTML : defaults;
            results.hidden = false;
          })
          .catch(function () {});
      }, 260);
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) results.hidden = true;
    });
  });

  /* ---------- collection facets ---------- */
  function loadCollection(url, push) {
    var wrap = $('[data-collection-results]');
    if (!wrap) { window.location.href = url; return; }
    wrap.classList.add('loading');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-collection-results]', '[data-collection-facets]', '[data-collection-toolbar]'].forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          var target = $(sel);
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        });
        if (push !== false) window.history.pushState({ url: url }, '', url);
        wrap.classList.remove('loading');
        var top = $('[data-collection-top]');
        if (top) window.scrollTo({ top: top.getBoundingClientRect().top + window.pageYOffset - 100, behavior: 'smooth' });
      })
      .catch(function () { window.location.href = url; });
  }

  document.addEventListener('change', function (e) {
    var form = e.target.closest('form[data-facet-form]');
    if (form) {
      var params = new URLSearchParams(new FormData(form)).toString();
      loadCollection(window.location.pathname + (params ? '?' + params : ''));
      return;
    }
    var sort = e.target.closest('[data-sort]');
    if (sort) {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      loadCollection(u.toString());
    }
  });
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-facet-link]');
    if (link) { e.preventDefault(); loadCollection(link.href); }
    var pag = e.target.closest('[data-collection-results] .pagination a, [data-pagination] a');
    if (pag) { e.preventDefault(); loadCollection(pag.href); }
  });
  window.addEventListener('popstate', function () { if ($('[data-collection-results]')) loadCollection(window.location.href, false); });

  /* view toggle */
  $$('[data-view]').forEach(function (btn) {
    on(btn, 'click', function () {
      var cols = btn.getAttribute('data-view');
      var grid = $('[data-collection-results] .product-grid') || $('.product-grid');
      if (grid) grid.style.setProperty('--cols', cols);
      $$('[data-view]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      try { localStorage.setItem('grid-cols', cols); } catch (err) {}
    });
  });

  /* ---------- product page ---------- */
  $$('[data-product]').forEach(function (root) {
    var variantsScript = $('[data-variants]', root);
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    if (!$$('[data-option-index]', root).length) return; // single-variant product

    var idInput = $('[data-variant-id]', root);
    var priceEl = $('[data-product-price]', root);
    var stockEl = $('[data-product-stock]', root);
    var submit = $('[data-add-button]', root);
    var skuEl = $('[data-product-sku]', root);

    function selectedOptions() {
      return $$('[data-option-index]', root)
        .filter(function (i) { return i.checked || i.tagName === 'SELECT'; })
        .map(function (i) { return { index: parseInt(i.getAttribute('data-option-index'), 10), value: i.value }; })
        .sort(function (a, b) { return a.index - b.index; })
        .map(function (o) { return o.value; });
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });

      $$('[data-option-value]', root).forEach(function (el) { el.parentNode.classList.remove('is-unavailable'); });

      if (!match) {
        if (submit) { submit.disabled = true; submit.querySelector('span').textContent = strings.unavailable || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = '<span>' + formatMoney(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<s>' + formatMoney(match.compare_at_price) + '</s>';
          priceEl.classList.add('price--sale');
        } else { priceEl.classList.remove('price--sale'); }
        priceEl.innerHTML = html;
      }
      if (skuEl) skuEl.textContent = match.sku || '';
      if (stockEl) {
        stockEl.classList.toggle('product__stock--out', !match.available);
        var label = $('[data-stock-label]', stockEl);
        if (label) label.textContent = match.available ? (stockEl.getAttribute('data-in-stock') || 'In stock') : (strings.soldOut || 'Sold out');
      }
      if (submit) {
        submit.disabled = !match.available;
        var s = submit.querySelector('span');
        if (s) s.textContent = match.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      }
      if (match.featured_media) {
        var target = $('[data-media-id="' + match.featured_media.id + '"]', root);
        if (target) showMedia(root, match.featured_media.id);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());

      $$('[data-option-label-value]', root).forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-label-value'), 10);
        el.textContent = chosen[idx] || '';
      });
    }

    $$('[data-option-index]', root).forEach(function (i) { on(i, 'change', update); });
    update();
  });

  function showMedia(root, id) {
    $$('[data-media-id]', root).forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-media-id') === String(id)); });
    $$('[data-thumb-id]', root).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb-id') === String(id)); });
  }
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb-id]');
    if (!thumb) return;
    e.preventDefault();
    showMedia(thumb.closest('[data-product]') || document, thumb.getAttribute('data-thumb-id'));
  });

  /* ---------- hotspots ---------- */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.hotspot__dot');
    if (dot) {
      var spot = dot.closest('.hotspot');
      var wasOpen = spot.classList.contains('is-open');
      $$('.hotspot.is-open').forEach(function (s) { s.classList.remove('is-open'); });
      if (!wasOpen) spot.classList.add('is-open');
      return;
    }
    if (!e.target.closest('.hotspot__card')) $$('.hotspot.is-open').forEach(function (s) { s.classList.remove('is-open'); });
  });

  /* ---------- wishlist (local) ---------- */
  function wishlist() {
    try { return JSON.parse(localStorage.getItem('xtra-wishlist') || '[]'); } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem('xtra-wishlist', JSON.stringify(list)); } catch (e) {}
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = list.length; el.hidden = list.length === 0; });
  }
  function syncWishlist() {
    var list = wishlist();
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', list.indexOf(btn.getAttribute('data-wishlist-toggle')) > -1);
    });
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = list.length; el.hidden = list.length === 0; });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-wishlist-toggle');
    var list = wishlist();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); toast('Removed from wishlist'); }
    else { list.push(handle); toast('Saved to wishlist'); }
    saveWishlist(list);
    syncWishlist();
  });
  syncWishlist();

  /* ---------- counters ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = el.getAttribute('data-count');
        var num = parseFloat(String(target).replace(/[^\d.]/g, ''));
        if (isNaN(num)) return;
        var suffix = String(target).replace(/[\d.,]/g, '');
        var start = null;
        function tick(ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / 1400);
          var val = Math.floor(num * (1 - Math.pow(1 - p, 3)));
          el.textContent = val.toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(tick); else el.textContent = target;
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: .4 });
    $$('[data-count]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- sticky header ---------- */
  var header = $('[data-sticky-header]');
  if (header) {
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      header.classList.toggle('is-stuck', y > 60);
      last = y;
    }, { passive: true });
  }

  /* restore grid preference */
  try {
    var saved = localStorage.getItem('grid-cols');
    if (saved) {
      var g = $('.product-grid');
      if (g) g.style.setProperty('--cols', saved);
      var b = $('[data-view="' + saved + '"]');
      if (b) { $$('[data-view]').forEach(function (x) { x.classList.remove('is-active'); }); b.classList.add('is-active'); }
    }
  } catch (e) {}

  refreshCartUI();
})();
